import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSearch } from '@fortawesome/pro-regular-svg-icons';
import './NewCircleModalFooter.scss';

import { CATALOG_IMAGE_FALLBACK } from '../../../../Helpers/shop_helpers';

import Tooltip from '../../../General/Tooltip';
import SmartImage from '../../../General/SmartImage';
import Loader from '../../../Loader/Loader';

const NewCircleModalFooter = props => {
  const { selectedIndustries, selectedDepartments, selectedBrands, selectedCurators, activePanel } = props;
  const { canGoNextData, customSubmit, canSearch, idx } = activePanel;

  const selectedCatalog = [...selectedIndustries, ...selectedDepartments];
  return (
    <div className='new-circle-modal-footer'>
      <div className='selected-groups'>
        {selectedCatalog.length ? (
          <div className='selected-group'>
            <div className='title'>Selected Categories</div>
            <div className='items'>
              {selectedCatalog.map(item => {
                const remove = () =>
                  item.Industry_id
                    ? props.setSelectedDepartments(selectedDepartments.filter(d => d.id !== item.id))
                    : props.setSelectedIndustries(selectedIndustries.filter(i => i.id !== item.id));
                return (
                  <div onClick={remove} className='item'>
                    <img src={item.exampleProductImage || CATALOG_IMAGE_FALLBACK} alt={item.name} />
                    <div className='name-container'>
                      <div className='name'>{item.name}</div>
                    </div>
                    <div className='close-icon'>
                      <FontAwesomeIcon icon={faTimes} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
        {selectedBrands.length ? (
          <div className='selected-group'>
            <div className='title'>Selected Brands</div>
            <div className='items'>
              {selectedBrands.map(item => {
                const remove = () => props.setSelectedBrands(selectedBrands.filter(b => b.id !== item.id));
                return (
                  <div onClick={remove} key={item.id} className='item'>
                    <SmartImage src={item.logo || item.exampleProductImage || CATALOG_IMAGE_FALLBACK} fallbackText={item.name} alt={item.name} />
                    <div className='name-container'>
                      <div className='name'>{item.name}</div>
                    </div>
                    <div className='close-icon'>
                      <FontAwesomeIcon icon={faTimes} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
        {selectedCurators.length ? (
          <div className='selected-group'>
            <div className='title'>{props.activeGroup ? 'Curators To Add' : 'Selected Curators'}</div>
            <div className='items'>
              {selectedCurators.map(item => {
                const remove = () => props.setSelectedCurators(selectedCurators.filter(c => c.id !== item.id));
                return (
                  <div onClick={remove} key={item.id} className='item full-width-image'>
                    <SmartImage src={item.image || CATALOG_IMAGE_FALLBACK} fallbackText={item.name} alt={item.name} />
                    <div className='name-container'>
                      <div className='name'>{item.name}</div>
                    </div>
                    <div className='close-icon'>
                      <FontAwesomeIcon icon={faTimes} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
      <div className='actions'>
        {canSearch && (
          <div onClick={props.pressToSearch} className='action-btn search'>
            <FontAwesomeIcon icon={faSearch} />
          </div>
        )}
        {idx > 0 && (
          <div onClick={props.goToPreviousPanel} className='action-btn secondary'>
            Back
          </div>
        )}
        {customSubmit ? (
          customSubmit.map(action => (
            <div
              key={action.label}
              onClick={action.onClick}
              className={cn('action-btn', action.className, { disabled: action.disabled, loading: action.isLoading })}
            >
              {action.label}
              {action.isLoading && <Loader size={64} />}
            </div>
          ))
        ) : (
          <Tooltip content={canGoNextData?.tooltip} visible={!canGoNextData?.enabled} placement='top' trigger='click'>
            <div onClick={props.goToNextPanel} className={cn('action-btn primary', { disabled: canGoNextData?.disabled })}>
              {canGoNextData?.disabled ? canGoNextData?.disabledBtnText : 'Next'}
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

NewCircleModalFooter.propTypes = {
  activePanel: PropTypes.object.isRequired,
  goToNextPanel: PropTypes.func.isRequired,
  goToPreviousPanel: PropTypes.func.isRequired,
  selectedIndustries: PropTypes.array.isRequired,
  selectedDepartments: PropTypes.array.isRequired,
  pressToSearch: PropTypes.func.isRequired,
  activeGroup: PropTypes.object
};

export default NewCircleModalFooter;
